import { useState } from 'react';

import QnaReport from '@/components/atom/icon/report/QnaReport';
import UserBlock from '@/components/atom/icon/report/UserBlock';
import UserReport from '@/components/atom/icon/report/UserReport';
import UserUnBlock from '@/components/atom/icon/report/UserUnBlock';

import useModal from '../useModal';
import useToast from '../useToast';

const REPORT_TYPE = {
  QUESTION: 'question',
  ANSWER: 'answer',
  BOARD_POST: 'board_post',
  BOARD_POST_COMMENT: 'board_post_comment',
} as const;

type REPORT_TYPE = (typeof REPORT_TYPE)[keyof typeof REPORT_TYPE];

export interface ReportData {
  targetId: string | number;
  targetType: REPORT_TYPE;
  roleId: string;
  role: string;
  isBlocked: boolean;
}
const useReviewReportModal = () => {
  const [showReportModal, setShowReportModal] = useState<boolean>(false);
  const [reportData, setReportData] = useState<ReportData>();
  const reportItems = [
    {
      Icon: () => <UserReport />,
      text: '사용자 신고',
      onClick: () => {
        showToast({
          message: '선택한 사용자를 신고했어요.',
        });
        closeModal();
        onCloseReportModal();
      },
    },
    {
      Icon: () => (isBlocked ? <UserUnBlock /> : <UserBlock />),
      text: '사용자 차단',
      onClick: () => {
        showToast({
          message: '선택한 사용자를 차단했어요.',
        });
        closeModal();
        onCloseReportModal();
      },
    },
    {
      Icon: () => <QnaReport />,
      text: '리뷰 신고',
      onClick: () => {
        showToast({
          message: '선택한 리뷰를 신고했어요',
        });
        closeModal();
        onCloseReportModal();
      },
    },
  ];

  const { closeModal } = useModal();
  const { showToast } = useToast();
  const isBlocked = reportData?.isBlocked;

  const onCloseReportModal = () => {
    setShowReportModal(false);
    setReportData(undefined);
  };

  const onShowReportModal = (data: ReportData) => {
    setReportData(data);
  };

  const openReportModal = () => {
    setShowReportModal(true);
  };

  return {
    showReportModal,
    onShowReportModal,
    onCloseReportModal,
    openReportModal,
    reportData,
    reportItems,
  };
};

export default useReviewReportModal;
